import { useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { useUser } from '../features/auth/useUser';
import { usePollCreditRefreshAfterPurchase } from './usePollCreditRefreshAfterPurchase';
import { clearPurchaseMarker } from '../features/payments/purchaseMarker';
import { PurchasePointsModal } from '../components/payments/PurchasePointsModal';
import '../styles/buttons.css';

/**
 * ポイント購入モーダルを任意のページから呼び出すフック
 * 管理者 → PurchasePointsModal を表示
 * 非管理者 → 「管理者にお問い合わせください」モーダルを表示
 */
export function usePurchaseModal() {
  const { isAdmin } = useUser();
  const { start } = usePollCreditRefreshAfterPurchase();
  const [isPurchaseOpen, setIsPurchaseOpen] = useState(false);
  const [isNonAdminOpen, setIsNonAdminOpen] = useState(false);

  const openPurchaseModal = useCallback(() => {
    if (isAdmin) {
      setIsPurchaseOpen(true);
    } else {
      setIsNonAdminOpen(true);
    }
  }, [isAdmin]);

  const purchaseModals = (
    <>
      <PurchasePointsModal
        isOpen={isPurchaseOpen}
        onClose={() => setIsPurchaseOpen(false)}
        // インライン成功 (経路 A): 渡された情報で直接ポーリングを起動する。
        // 現在ページのまま、ヘッダー残高を含めてフルリロードなしに反映する。
        // リダイレクトしていないので、経路 B 用に書いたマーカーは消しておく。
        onSuccess={(info) => {
          start({
            baselineBalance: info.baselineBalance,
            expectedPoints: info.expectedPoints,
            key: info.paymentIntentId,
          });
          clearPurchaseMarker();
        }}
      />
      {isNonAdminOpen && createPortal(
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0, 0, 0, 0.75)',
            backdropFilter: 'blur(4px)',
            zIndex: 'var(--z-modal)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
          }}
          onClick={() => setIsNonAdminOpen(false)}
        >
          <div
            style={{
              background: 'rgba(12, 12, 12, 0.95)',
              border: '1px solid rgba(255, 255, 255, 0.12)',
              borderRadius: '16px',
              maxWidth: '400px',
              width: '100%',
              padding: '24px',
              textAlign: 'center',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <p style={{ color: 'rgba(245, 241, 230, 0.85)', fontSize: '14px', lineHeight: 1.6, margin: '0 0 20px' }}>
              ポイントの購入は管理者のみ可能です。<br />
              組織の管理者にお問い合わせください。
            </p>
            <button
              type="button"
              className="btn-modal"
              onClick={() => setIsNonAdminOpen(false)}
            >
              閉じる
            </button>
          </div>
        </div>,
        document.body,
      )}
    </>
  );

  return { openPurchaseModal, purchaseModals };
}
